// [2024-05-08] Store 액션 정의
import { Patient, Drug, AIReview, DrugProductLabel } from "common/models/types";
import { createAction } from "@reduxjs/toolkit";

// 환자 관련 액션
export const setPatientList = createAction<Patient[]>("SET_PATIENT_LIST");
export const setPatient = createAction<Patient>("SET_PATIENT");
export const removePatient = createAction<number>("REMOVE_PATIENT");
export const touchPatientUpdatedAt = createAction<number>("TOUCH_PATIENT_UPDATED_AT");

// 처방전 관련 액션
export const setAIReview = createAction<AIReview>("SET_REVIEW");
export const removeAIReview = createAction<number>("REMOVE_REVIEW");

// 참고자료 관련 액션
export const setReference = createAction<Drug>("SET_REFERENCE");
export const removeReference = createAction<string>("REMOVE_REFERENCE");

// 허가사항 캐시 액션 (itemCode별 허가사항 조회 결과 캐싱)
export const setDrugLabels = createAction<{ itemCode: string; labels: DrugProductLabel[] }>(
  "SET_DRUG_LABELS"
);

export type Action =
  | ReturnType<typeof setPatientList>
  | ReturnType<typeof setPatient>
  | ReturnType<typeof removePatient>
  | ReturnType<typeof touchPatientUpdatedAt>
  | ReturnType<typeof setAIReview>
  | ReturnType<typeof removeAIReview>
  | ReturnType<typeof setReference>
  | ReturnType<typeof removeReference>
  | ReturnType<typeof setDrugLabels>;
